<template>
  <b-table v-bind="tableAttributes" :fields="fields" :items="items">

     <template #cell(title)="data" class="w-50 p-0">
       <m-a class="text-dark text-decoration-none" target="_blank"
            :href="{name:setRouteLinkForSiteRoute(),params:{slug:data.item.slug}}">
        <span class="text-wrap p-0">
        {{ data.item.title }}
        </span>
       </m-a>

     </template>
     <template #cell(thumbnail)="data">
       <m-a target="_blank"
            :href="{name:setRouteLinkForSiteRoute(),params:{slug:data.item.slug}}">
         <b-img :src="data.item.thumbnail" v-bind="mainProps"  style="object-fit: cover" />
       </m-a>
     </template>

    <template #cell(author)="data">
      {{ data.item?.author?.name }} {{ data.item?.author?.last_name }}
    </template>

     <template #cell(status)="data">
       <status-changer item-type="content" :item="data.item"/>
     </template>

     <template #cell(action)="data">


       <div v-if="restoreState == true">
        <span
            class="h4"
            v-b-tooltip.hover
            title="حذف دائمی"
        >
        <b-icon icon="trash" class="m-3" @click="forceDeleteContent(data.item)"></b-icon>
      </span>

         <span
             class="h4"
             v-b-tooltip.hover
             title="بازگردانی"
         >
        <b-icon
            icon="arrow-clockwise"
            class="m-3"
            @click="restore(data.item)"
        ></b-icon>
      </span>

       </div>

       <div v-else>

         <span class="h4" v-b-tooltip.hover title="حذف">
        <b-icon icon="trash" class="m-3" @click="deleteContent(data.item)"></b-icon>
      </span>

         <span class="h4" v-b-tooltip.hover title="ویرایش">
        <router-link target="_blank"
                     :to="{ name: 'UpdateContent', params: { slug: data.item.slug } }"
        >
          <b-icon icon="pencil" class="m-3 text-dark "></b-icon>
        </router-link>
      </span>

         <duplicate-item :item="data.item" :item-type="$route.name === 'PagesDashboard' ? 'page' : 'post' "/>

       </div>


    </template>
  </b-table>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import StatusChanger from "../../genralComponents/StatusChanger";
import DuplicateItem from "../../genralComponents/DuplicateItem";

export default {
  name: "tabelItems",
  components: {StatusChanger, DuplicateItem,},
  props: ["items", "restoreState"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "thumbnail", label: "عکس"},
        {key: "title", label: "عنوان"},
        {key: "status", label: "وضعیت"},
        {key: "author", label: "نویسنده"},
        {key: "action", label: ""},
      ],
      mainProps: {width: 75, height: 75, class: 'p-0 rounded'}
    };
  },
  methods: {
    formatNumber,
    deleteContent(item) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        this.$store.dispatch("Content/deleteContent", item);
      }
    },
    restore(item) {
      if (confirm(' بازگردانی  شود؟')) {
        this.$store.dispatch("Content/restoreContent", item.id);
      }
    },
    forceDeleteContent(item) {
      if (confirm('آیا از حذف  دائمی اطمینان دارید؟')) {
        this.$store.dispatch("Content/forceDeleteContent", item);
      }
    },
    setRouteLinkForSiteRoute() {
      const routeName = this.$route.name;
      if (routeName === 'PostsDashboard') return 'SinglePost'
      if (routeName === 'PagesDashboard') return 'SinglePage'
    }
  },
};
</script>